var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    attrs: {
      "className": "header--light"
    }
  }, [_c('sub-visual', {
    attrs: {
      "sh": "기업소개",
      "sh2": "기업문화",
      "tabActive": "기업문화",
      "bg": "/images/sub/visual/sv1-5.jpg"
    }
  }), _c('div', {
    staticClass: "text-center color-white bg-point py-50 py-lg-74 w-100"
  }, [_c('v-container', [_c('h3', {
    staticClass: "tit font-weight-light font-italic",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._v(" 함께여서 즐거운 "), _c('strong', {
    staticClass: "font-weight-bold"
  }, [_vm._v("세일즈웍스 코리아")])]), _c('p', {
    staticClass: "tit-txt mt-10 mt-lg-24",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 긍정적인 에너지를 나누며 함께 문화를 만들어가는 세일즈웍스는 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 다양한 경험을 통해 하루하루 성장해나가고 있습니다. ")])])], 1), _c('section', {
    staticClass: "section--sm section--last"
  }, [_c('v-container', [_c('company-culture')], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }